"use client";

import { TopPopupWaitFreeChargeCompletePopupInner } from "@api/models/TopPopupWaitFreeChargeCompletePopupInner";
import { STORE_KEYS } from "app/constants";
import { useStaticStore } from "app/hooks";
import Image from "next/image";
import Link from "next/link";
import { MdClose } from "react-icons/md";

export function PopupContentWaitFree({
  content,
}: {
  content: TopPopupWaitFreeChargeCompletePopupInner;
}) {
  const { mutate: setIsOpen } = useStaticStore(STORE_KEYS.popup);
  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <div className="dialog-content">
      <h2 className="dialog-h mode-waitfree">
        「待つと無料」購読中作品の
        <br />
        チャージが完了しました。
      </h2>
      <div className="dialog-main">
        <Link href={content.url || ""} className="dialog-main-link" autoFocus>
          <h3 className="dialog-main-link-h">{content.title}</h3>
          {content.image?.url && (
            <figure className="dialog-main-fig">
              <Image
                className="dialog-main-img"
                src={content.image?.url}
                width={content.image?.width ?? 0}
                height={content.image?.height ?? 0}
                alt={content.title ? content.title + "の画像" : ""}
              />
            </figure>
          )}
          <span className="dialog-main-btn">読む</span>
        </Link>
      </div>
      <button className="dialog-close" onClick={handleClose}>
        <MdClose aria-label="閉じる" size={24} className="dialog-close-icon" />
      </button>
      <div className="dialog-f">
        <button className="dialog-f-btn" onClick={handleClose}>
          閉じる
        </button>
      </div>
    </div>
  );
}
